import {kExerciserTexts} from "../../../constants/texts";
import {isNullOrUndefined} from "../../../services/Validator";

// METHODS
// ---- Compute flash appreciation
export function computeExerciserResultsAppreciation(successRatio) {
    if (isNullOrUndefined(successRatio) || typeof successRatio !== 'number' || successRatio > 100 || successRatio < 0) {
        return kExerciserTexts.appreciationErrorScore
    } else {
        if (successRatio === 100) {
            return kExerciserTexts.perfectScore
        } else if (successRatio >= 80) {
            return kExerciserTexts.veryGoodScore
        } else if (successRatio >= 60) {
            return kExerciserTexts.goodScore
        } else if (successRatio >= 50) {
            return kExerciserTexts.averageScore
        } else if (successRatio >= 30) {
            return kExerciserTexts.underScore
        } else {
            return kExerciserTexts.nullScore
        }
    }
}